export default __webpack_public_path__ + "static/media/tri-1.36bbf60a.svg";